import React from 'react';
import Icon from '@mdi/react';
import { mdiEmoticonHappyOutline  } from '@mdi/js';
import theme from '../theme'; 

export const EngagedFaceIcon = size => (
  <Icon 
    size={size}
    path={mdiEmoticonHappyOutline }
    title="Engaged"
    color={theme.engaged}
  />
);